import { render } from "./SessionRegistration.vue?vue&type=template&id=85856990&scoped=true&ts=true"
import script from "./SessionRegistration.vue?vue&type=script&lang=ts"
export * from "./SessionRegistration.vue?vue&type=script&lang=ts"

import "./SessionRegistration.vue?vue&type=style&index=0&id=85856990&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85856990"]])

export default __exports__